import { TextField } from "@mui/material";
import { ReturnAddress } from "../../types/evidence";
import { FIELD } from "./styles";

const ADDRESS_FIELDS: [keyof ReturnAddress, string][] = [
  ['address_line_1', "Address line"],
  ['admin_area_2', "City"],
  ['admin_area_1', "State"],
  ['postal_code', "Postal code"],
  ['country_code', "Country code"],
];

type Props = {
  value: ReturnAddress;
  onChange: (value: ReturnAddress) => void;
  disabled?: boolean;
};

export default function ReturnAddressFields({ value, onChange, disabled }: Props) {
  return ADDRESS_FIELDS.map(([key, label]) => (
    <TextField
      key={key}
      label={label}
      size="small"
      disabled={disabled}
      value={value[key]}
      onChange={(e) => onChange({ ...value, [key]: e.target.value })}
      sx={FIELD}
    />
  ));
}
